import * as React from 'react';
import styles from './index.module.less';
import type { IRecommendDataItem } from '../../model';

interface IProps {
    title: string;
    dataList: IRecommendDataItem[];
    linkList: IRecommendDataItem[];
}
const CompRecommendItem: React.FC<IProps> = (props) => {
    return (
        <div className={ `${styles['four-sug-content']} ${styles['four-sug-left']}` }>
            <h3 className={ styles['recommend-title'] }>{props.title}</h3>
            <ul className={ styles['recommend-ul'] }>
                {props.dataList.map((item) => {
                    return (
                        <li
                            key={ item.title }
                            className={ styles['recommend-li'] }>
                            <a
                                className={ styles['four-sug-link'] }
                                href={ item.link }>
                                {item.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
            {props.linkList.map((item) => {
                return (
                    <a
                        href={ item.link }
                        key={ item.title }
                        className={ `${styles['four-li-link']} sf-learn-more sf-less-able` }
                    >
                        <span className="text">{item.title}</span>
                        <span className="ui-icon icon-icon_arrow-right"></span>
                    </a>
                );
            })}
        </div>
    );
};
export default CompRecommendItem;
